// src/components/Calendar/EventDetailPopover.jsx
import React from 'react';
import { Popover, Box, Typography, Button, Stack } from '@mui/material';
import HowToVoteIcon from '@mui/icons-material/HowToVote';

export default function EventDetailPopover({
    anchorEl,
    detail,
    onClose,
    onEdit,
    onDelete,
    onVote,
}) {
    if (!detail) return null;

    const {
        id,
        vote,
        editable,
        content_type,
        host,
        startDate,
        startTime,
        endDate,
        endTime,
        type,
        urgent,
        people,
        location,
        title,
    } = detail;

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Box sx={{ p: 2, minWidth: 260 }}>
                <Typography variant="subtitle2" gutterBottom>
                    상세 정보
                </Typography>

                {/* ─── 일정 기본 정보 ─── */}
                <Typography variant="body2">
                    {content_type === 'internal' ? '컨텐츠 진행자' : '벙주'} : {host}
                </Typography>
                <Typography variant="body2">
                    시작 : {startDate} / {startTime}
                </Typography>
                <Typography variant="body2">
                    종료 : {endDate} / {endTime}
                </Typography>

                {content_type === 'internal' ? (
                    <>
                        <Typography variant="body2">컨텐츠명 : {title}</Typography>
                        <Typography variant="body2">장소 : {location}</Typography>
                    </>
                ) : (
                    <>
                        <Typography variant="body2">
                            종류 : {type}
                            {urgent && ' (급벙)'}
                        </Typography>
                        <Typography variant="body2">인원 : {people}</Typography>
                        <Typography variant="body2">장소 : {location}</Typography>
                    </>
                )}

                {/* ─── 첫 줄: 수정‧삭제 (권한 있을 때만) ─── */}
                {editable && (
                    <Stack direction="row" spacing={1} mt={2}>
                        <Button size="small" variant="outlined" onClick={() => onEdit(id)}>
                            수정
                        </Button>
                        <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            onClick={() => onDelete(id)}
                        >
                            삭제
                        </Button>
                    </Stack>
                )}

                {/* ─── 둘째 줄: 투표하기 (있을 때만) ─── */}
                {vote && (
                    <Box mt={editable ? 1 : 2}>
                        <Button
                            size="small"
                            variant="contained"
                            fullWidth
                            endIcon={<HowToVoteIcon />}
                            onClick={() => onVote?.({ id, title, type, vote })}
                        >
                            투표하기
                        </Button>
                    </Box>
                )}
            </Box>
        </Popover>
    );
}
